import { Container } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Footer from "./components/LayoutFooter";
import NavMenu from "./components/NavMenu";
import Wait from "./components/Wait";
import { ContactContext } from "./context/contact/ContactContext";
import ProtectedRoutes from "./protectedRoutes";

const AppContent = () => {
  const [isLoading, setLoading] = useState(true);
  const { getStates, getVendFlowEnrollment } = useContext(ContactContext);

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getStates(), getVendFlowEnrollment()]);
      setLoading(false);
    };
    fetchData2();
  }, []);

  return (
    <>
      {isLoading ? (
        <Wait />
      ) : (
        <>
          <NavMenu />
          {/* <Container> */}
          <ProtectedRoutes />
          {/* </Container> */}
          <Footer />
          <br />
        </>
      )}
    </>
  );
};

export default AppContent;
